import * as DOMPurify from 'dompurify';

/**
 * @param {HTMLElement} element
 * @param {import('vue').DirectiveBinding} binding
 */
function applySanitizedHtml(element, binding) {
  const { value } = binding;

  element.innerHTML = DOMPurify.default.sanitize(value, { USE_PROFILES: { html: false } });
}

export default {
  // Vue Hook Functions
  mounted(el, binding) {
    applySanitizedHtml(el, binding);
  },
  updated(el, binding) {
    applySanitizedHtml(el, binding);
  },
};
